import { useMediaQueryList } from "@hooks/use-media-query";

/**
 * Defines the display mode for bulk action buttons based on screen size and device type.
 */

/**
 * Hook that determines the responsive display mode for bulk action buttons.
 *
 * Automatically calculates the optimal button layout based on screen size and device capabilities
 * using MUI breakpoints. The mode updates reactively when the viewport or device type changes.
 *
 * @returns The current bulk actions display mode (collapsed, compact, or full)
 */
export function useBulkActionsMode() {
  const {
    isScreenSmOrSmaller,
    isScreenMd,
    isHoverSupported
  } = useMediaQueryList();
  switch (true) {
    case !isHoverSupported:
    case isScreenSmOrSmaller:
      {
        return "collapsed";
      }
    case isScreenMd:
      {
        return "compact";
      }
    default:
      {
        return "full";
      }
  }
}